import { OrderSimRequest } from '@support/models/order-sim-request.model';
import { OrderHistoryResponseV2, OrderHistorySearchRequestV2 } from '@core/models/order-history.model';

export class CancelOrderAction {
  static readonly type = '[Api Order] Cancel order';
  constructor(
    public orderServiceId: number,
    public reason: string
  ) {}
}

export class OrderBulkSimAction {
  static readonly type = '[OrderBulkSim] Order bulk sim';
  constructor(public orderSimRequest: OrderSimRequest) {}
}

export class OrderBulkSimSuccessAction {
  static readonly type = '[OrderBulkSim] Order bulk sim success';
}

export class OrderBulkSimErrorAction {
  static readonly type = '[OrderBulkSim] Order bulk sim error';
  constructor(public error: string) {}
}

export class SupportResetAction {
  static readonly type = '[Support] reset support state';
}

export class OrderHistorySearchV2Action {
  static readonly type = '[Api OrderHistory V2] Order history Search V2';
  constructor(public searchRequest: OrderHistorySearchRequestV2) {}
}

export class OrderHistorySearchV2SuccessAction {
  static readonly type = '[Api OrderHistory V2] Order history search success V2';
  constructor(public searchResponse: OrderHistoryResponseV2) {}
}

export class OrderHistorySearchErrorV2Action {
  static readonly type = '[Api OrderHistory V2] Order history search error V2';
  constructor(public error: string) {}
}

export class OrderHistoryAppendNewOrdersV2Action {
  static readonly type = '[Api OrderHistory V2] Append extra orders to searchresult';
  constructor(public searchRequest: OrderHistorySearchRequestV2) {}
}

export class OrderHistoryAppendNewOrdersV2SuccessAction {
  static readonly type = '[OrderHistory V2] Append extra orders to searchresult success';
  constructor(public response: OrderHistoryResponseV2) {}
}

export class OrderHistoryAppendNewOrdersV2ErrorAction {
  static readonly type = '[OrderHistory V2] Append extra orders to searchresult error';
  constructor(public error: string) {}
}

export class MissingImeiCountAction {
  static readonly type = '[Order History V2] Get number of missing IMEI';
  constructor(public searchRequest: OrderHistorySearchRequestV2) {}
}

export class MissingImeiCountErrorAction {
  static readonly type = '[Order History V2] Get number of missing IMEI Success';
  constructor(public error: string) {}
}

export class ManuallySetOrderStatusToCancelledAction {
  static readonly type = '[Order History V2] Manually set OrderStaus in state to Cancelled';
  constructor(public orderId: number) {}
}
